<template>
    <div class="loader-box">
        <div class="loader-2"></div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
        }
    }
}
</script>

<style scoped>
</style>
